import apiClient from "../shared/API/apiClient";

const carbonReportService = {

  getDashboard: params =>
    apiClient.get(
      "/api/reports/carbon-performance-dashboard",
      {
        params
      }
    )
};

export default carbonReportService;